// removed by extract-text-webpack-plugin
module.exports = {"button":"fonts__button__33GaB"};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/styles/fonts.scss
// module id = ./app/javascript/packs/Shared/styles/fonts.scss
// module chunks = 0 1